import React, { FunctionComponent, useState } from "react";
import {
  Table,
  Tooltip,
  Grid,
  Fab,
  MuiThemeProvider,
} from "@material-ui/core";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import { CreditCustomerReferenceList } from "./CreditCustomerReferenceList";
import { api } from "../../../../api";
import { SnackBar } from "../../../SnackBar";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Code",
  "Email",
  "Mobile Number",
  "Credit Limit",
  "Available Balance",
  "Customer Reference",
  "Status",
  ""
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface CreditCustomersTableProps {
  creditCustomer: any;
}
export const CreditCustomersTable: FunctionComponent<
  CreditCustomersTableProps
> = ({ creditCustomer }) => {
  const getMuiTheme = useTableStyles();
  const [referenceDetails, setReferenceDetails] = useState<Array<object>>([]);
  const [referenceeName, setReferenceeName] = useState<string>("");
  const [showReferenceDetails, setShowReferenceDetails] = useState<Boolean>(
    false
  );
  const [statusUpdate, setStatusUpdate] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");

  const getReferenceDetails = async (id: number, name: string) => {
    try {
      const referenceCreditCustomers = await api.get(`customers-credit/${id}`);
      setReferenceeName(name);
      setReferenceDetails(referenceCreditCustomers);
      setShowReferenceDetails(true);
    } catch (error:any) {
      setSnackbarColor("red");
      setStatusUpdate(error.error);
    }
  };
  const closeReferenceDialog = () => {
    setShowReferenceDetails(false);
  };
  const onCloseSnackbar = () => {
    setStatusUpdate("");
  };
  if (creditCustomer && creditCustomer.length > 0) {
    return (
      <div>
        <SnackBar
          status={statusUpdate}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Credit Customer List"}
              data={creditCustomer.map((customer: any) => {
                return [
                  customer.customer_name,
                  customer.code,
                  customer.email !== null ? (
                    <Tooltip title={customer.email}>
                      <div>{customer.email.substr(0, 9)}...</div>
                    </Tooltip>
                  ) : ("-"),
                  customer.mobile_number,
                  customer.credit_limit,
                  customer.avail_bal,
                  customer.customer_ref,
                  customer.status_description,
                  <Grid container direction="row" spacing={2}>
                    <Grid item>
                      <Fab
                        size="small"
                        aria-label="edit"                      
                        // color="primary"
                        style={{backgroundColor:"#3d5a79"}}
                        onClick={() =>
                          getReferenceDetails(
                            customer.id,
                            customer.customer_name
                          )
                        }
                      >
                        <Tooltip title="Reference Customer List">
                          <PeopleOutlineIcon/>
                        </Tooltip>
                      </Fab>
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        {showReferenceDetails ? (
          <CreditCustomerReferenceList
            referenceDetails={referenceDetails}
            referenceeName={referenceeName}
            closeReferenceDialog={closeReferenceDialog}
          />
        ) : null}
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Credit Customer List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
